import { Button, ResponsiveDrawer, Typography } from '@fox/atoms';
import { FlexColumnSmallSpaced, Padded, ResponsiveCSSGrid } from '@fox/layout';
import React from 'react';
import { TableWrapper } from '../financial-details/receipts';
import { ActionCentreTable } from './action-centre-table';
import { IActionCentreViewProps } from './contracts';
import { RenderGroupedFilterList } from './filters/filters';
import { ExportButton, PdfButton, SearchInput, SourceFilter } from './shared-components';
export function MobileView({
	filter,
	columnsResult,
	sourceOptions,
	showFilters,
	enableClearFilters,
	setPage,
	setFilters,
	filters,
	sort,
	setSort,
	actionId,
	page,
	pageSize,
	disableExport,
	updateFilters,
	setSourceFilter,
	showSearch,
	rowsExpandedOnSmallScreens
}: IActionCentreViewProps) {
	const [drawerOpen, setDrawerOpen] = React.useState<boolean>(false);

	return (
		<TableWrapper key={filter}>
			<Typography sx={{ paddingBottom: '1rem' }} variant="h5">
				{columnsResult.name}
			</Typography>
			<ResponsiveCSSGrid itemWidth="300px" gap="1.5rem" style={{ paddingTop: '1rem' }}>
				{showSearch ? <SearchInput updateFilters={updateFilters} /> : null}
				{sourceOptions.length ? (
					<SourceFilter sourceOptions={sourceOptions} filter={filter} setSourceFilter={setSourceFilter} />
				) : null}
				{showFilters ? (
					<Button variant="primary" onClick={() => setDrawerOpen(true)}>
						Add filters
					</Button>
				) : null}
				{!disableExport ? (
					<>
						<ExportButton
							actionId={actionId}
							actionName={columnsResult?.name}
							columns={columnsResult.columns}
							source={sourceOptions.find(([key, value]) => key == filter?.toString())}
							filters={filters}
							sort={sort}
						/>
						<PdfButton actionId={actionId} sourceFilter={filter} filters={filters} sort={sort} />
					</>
				) : null}
			</ResponsiveCSSGrid>
			<ResponsiveDrawer
				headerVariant="h5"
				placement="bottom"
				title={'Action Centre filters'}
				width="100%"
				height="100%"
				style={{ height: '100%' }}
				open={drawerOpen}
				destroyOnClose
				onClose={() => {
					setDrawerOpen(false);
				}}
			>
				<FlexColumnSmallSpaced>
					<Padded style={{ paddingBottom: '8rem' }}>
						<RenderGroupedFilterList updateFilters={updateFilters} columns={columnsResult.columns} filters={filters} />
					</Padded>
					<ResponsiveCSSGrid
						itemWidth="300px"
						gap="1.5rem"
						style={{ position: 'fixed', bottom: 0, width: '100%', padding: '1rem' }}
					>
						<Button style={{ width: '100%' }} onClick={() => setDrawerOpen(false)} variant="primary">
							Apply filters
						</Button>
						<Button
							variant="secondary"
							style={{ width: '100%' }}
							disabled={!enableClearFilters}
							onClick={() => {
								setFilters([]);
								setPage(1);
							}}
						>
							{`Clear filters${filters?.length ? ` (${filters.length})` : ''}`}
						</Button>
					</ResponsiveCSSGrid>
				</FlexColumnSmallSpaced>
			</ResponsiveDrawer>
			<ActionCentreTable
				actionCentreColumns={columnsResult.columns}
				actionId={actionId}
				sourceFilter={filter}
				rowsExpandedOnSmallScreens={rowsExpandedOnSmallScreens}
				filters={filters}
				sort={sort}
				setSort={setSort}
				page={page}
				setPage={setPage}
				pageSize={pageSize}
			/>
		</TableWrapper>
	);
}
